import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";
import { _parallax, _parallaxScroller } from "../utils/_parallax";

import { _backgroundGradient } from "../utils/_backgroundGradient";
import { _section } from "../utils/_section";
import { _splitText } from "../utils/_splitText";
import gsap from "gsap";
import lottie from "lottie-web";

class OurApproach extends MainClass {
	private animation: lottie.AnimationItem | null = null;

	el: {
		mobile: {
			sections: NodeListOf<HTMLElement>;
		};
	};

	constructor(props: MAIN_CLASS_PARAMS) {
		super(props);

		this.el = {
			mobile: {
				sections: this.selector.querySelectorAll(".js-one-scroll-section"),
			},
		};

		this.init();
	}

	/**
	 * Initialize the class and set up animations.
	 */
	init() {
		const dataLottieDefault = document.querySelector("[data-lottie-default]");
		const dataLottieJson = dataLottieDefault?.getAttribute(
			"data-lottie-default",
		);
		const animationContainer = document.querySelector(".lottie-render");

		// Load the default animation
		if (animationContainer && dataLottieJson) {
			this.loadAnimation(animationContainer, dataLottieJson, false);
		}

		// Set up hover actions for elements
		this.setupHoverActions(animationContainer, dataLottieJson);

		//mobile animation
		let touchStartY = 0;
		let inertiaTimeout: any;
		let isOnTop = false;
		const sections = document.querySelectorAll(".js-one-scroll-section");
		let lottieFiles: { active: AnimationItem | null } = { active: null };
		let activeItem = 0;

		function renderLottie(element: any) {
			const container = element.querySelector(".lottie-box");
			const path = container?.dataset.lottie;

			if (!container) return;
			// animateTextIn(element);
			// If animation was already loaded, just play it
			if (container._lottieInstance) {
				container._lottieInstance.setSpeed(0.2);
				container._lottieInstance.goToAndPlay(0, true); // Restart from frame 0
				return;
			}

			// Load animation once
			const anim = lottie.loadAnimation({
				container,
				renderer: "svg",
				loop: false,
				autoplay: false,
				path,
			});

			container._lottieInstance = anim;
			lottieFiles.active = container;
			anim.goToAndStop(0, true); // Ensure it starts at frame 0
			anim.play();
		}

		document.querySelectorAll(".lottie-box").forEach((element) => {
			renderLottie(element.closest(".js-one-scroll-section")); // Adjust based on your structure
		});

		function fixViewToTop() {
			document.querySelector(".js-section-container")?.classList.add("on-top");
			sections[0].scrollIntoView({ behavior: "smooth" });
		}

		function handleTouchStart(event: TouchEvent) {
			touchStartY = event.touches[0].clientY;
		}

		let _currentItem: number | null = null;
		function sectionAnimate(activeItem: number | null) {
			if (_currentItem === activeItem) return;
			_currentItem = activeItem;

			document
				.querySelector(".js-one-scroll-section.active")
				?.classList.remove("active");

			if (activeItem === null) return;
			sections[activeItem].classList.add("active");

			renderLottie(sections[activeItem]);
			animateTextIn(sections[activeItem]);
		}

		function handleMove(event) {
			clearTimeout(inertiaTimeout); // Clear previous timeout if movement continues

			let deltaY;

			if (event.type === "touchmove") {
				const touchEndY = event.touches[0].clientY;
				deltaY = touchStartY - touchEndY;
			} else if (event.type === "wheel") {
				deltaY = event.deltaY;
			}

			if (Math.abs(deltaY) < 10) return;

			inertiaTimeout = setTimeout(() => {
				const elementTop = document
					.querySelector(".js-section-container")
					?.getBoundingClientRect().top;
				const elementBottom =
					sections[sections.length - 1].getBoundingClientRect().bottom + 5;
				let firstContentVisible = window.innerHeight / 2;
				// sections[activeItem].classList.remove('active');
				if (
					deltaY > 0 &&
					isOnTop &&
					sections[sections.length - 1]?.classList.contains("active")
				) {
					//last section
					isOnTop = false;
					if (elementBottom >= 100) {
						document
							.querySelector(".wp-block-section-our-approach")
							?.nextElementSibling?.scrollIntoView({ behavior: "smooth" });
					}
					return;
				} else if (
					deltaY < 0 &&
					!isOnTop &&
					elementBottom >= 100 &&
					elementTop < 0
				) {
					//scroll up go to last section
					// fixViewToTop();
					isOnTop = true;
					sectionAnimate(sections.length - 1);
					return;
				} else if (
					deltaY > 0 &&
					!isOnTop &&
					elementTop <= firstContentVisible &&
					elementBottom > 0
				) {
					//scroll down go to first section
					// fixViewToTop();
					sectionAnimate(0);
					isOnTop = true;
					return;
				} else if (isOnTop) {
					if (deltaY > 0) {
						activeItem =
							activeItem < sections.length - 1
								? activeItem + 1
								: sections.length - 1;
					} else if (deltaY < 0) {
						activeItem = activeItem > 0 ? activeItem - 1 : 0;
						if (elementTop > 0) {
							isOnTop = false;
							activeItem = 0;
							return;
						}
						if (activeItem === 0 && isOnTop) {
							document
								.querySelector(".js-section-container")
								?.scrollIntoView({ behavior: "smooth" });
						}
					}
					sectionAnimate(activeItem);
					return;
				}
			}, 100);
		}

		const handleLayout = () => {
			const titleEl = document.querySelector(
				".js-one-scroll-title",
			) as HTMLElement;
			const sectionEls = document.querySelectorAll(".js-one-scroll-section");

			if (titleEl && sectionEls.length > 0) {
				const titleHeight = titleEl.offsetHeight - 60;
				let maxDescriptionHeight = 0;
				sectionEls.forEach((el) => {
					const descriptionEl = el.querySelector(
						".lottie-description",
					) as HTMLElement;
					if (descriptionEl) {
						const height = descriptionEl.offsetHeight;
						if (height > maxDescriptionHeight) {
							maxDescriptionHeight = height;
						}
					}
				});
				sectionEls.forEach((el) => {
					(el as HTMLElement).style.paddingTop = `${titleHeight}px`;
				});
				const viewportHeight = window.innerHeight;
				sectionEls.forEach((el) => {
					let lottieBox = el.querySelector(".lottie-box") as HTMLElement;
					lottieBox.style.height =
						viewportHeight - (titleHeight + maxDescriptionHeight + 80) + "px";
				});
			}
			// animateLottie(document.querySelector('.lottie-box')?.parentElement);
		};

		const textListingWrapper = Array.from(
			document.querySelectorAll<HTMLElement>(".animate-heading-on-active"),
		).flatMap((wrapper) =>
			Array.from(wrapper.querySelectorAll<HTMLElement>("li")),
		);

		textListingWrapper.forEach((li) => {
			li
				.closest(".animate-heading-on-active")
				?.classList.remove("animate-heading-on-active");
			const text = li.innerHTML?.trim();
			if (text) {
				// Clear current content
				li.innerHTML = "";

				// Create wrapper div
				const div = document.createElement("div");
				// div.className = "animate-heading-on-active";
				div.innerHTML = text;

				// Append wrapped content
				li.appendChild(div);
				li.classList.add("animate-heading-on-active");
			}
		});

		const textAnimateWrapper = document.querySelectorAll<HTMLElement>(
			".animate-heading-on-active",
		);
		textAnimateWrapper.forEach((el) => {
			new _splitText({ target: el });
		});

		const animateTextIn = (el) => {
			const targets = el.querySelectorAll(".animate-heading-on-active");
			targets.forEach((target) => {
				gsap.fromTo(
					target,
					{ opacity: 0 },
					{ opacity: 1, duration: 0.5, delay: 0.6 },
				);
				const wordElements = target.querySelectorAll(".word");
				gsap.fromTo(
					wordElements,
					{ y: 72 },
					{
						y: 0,
						duration: 0.5,
						stagger: 0.05,
						delay: 0.5,
					},
				);
			});
		};

		// window.addEventListener("touchstart", handleTouchStart, { passive: true }); // Mobile
		// window.addEventListener("touchmove", handleMove, { passive: true }); // Mobile
		// document.addEventListener("wheel", handleMove);
		window.addEventListener("load", handleLayout);
		window.addEventListener("resize", handleLayout);

		// mobile animation
		new _parallaxScroller({
			target: this.selector,
			resize: (scroller) => {
				const _offset = _parallax.getOffset(scroller.target);

				scroller.offset.top = _offset.top;
				scroller.offset.bottom = _offset.bottom - window.innerHeight;
			},
			update: (scroller) => {
				const _progress = scroller.offset.current;
				const _currentItem =
					_progress < 0
						? null
						: Math.round(
								(this.el.mobile.sections.length - 1) * _parallax.abs(_progress),
						  );

				sectionAnimate(_currentItem);
			},
		});

		// console.log("OurApproach", this);
	}

	/**
	 * Load a Lottie animation into a container.
	 * @param container - The DOM element to render the animation in.
	 * @param path - The path to the Lottie JSON file.
	 * @param loop - Whether the animation should loop.
	 */
	private loadAnimation(container: Element, path: string, loop: boolean) {
		// Destroy the existing animation if it exists
		if (this.animation) {
			this.animation.stop();
			this.animation.destroy();
		}

		// Load the new animation
		this.animation = lottie.loadAnimation({
			container,
			path,
			renderer: "svg",
			loop,
			autoplay: true,
		});
	}

	/**
	 * Set up hover actions for elements with the "step-hover" class.
	 * @param animationContainer - The container for the Lottie animation.
	 * @param defaultJsonPath - The default Lottie JSON path.
	 */
	private setupHoverActions(
		animationContainer: Element | null,
		defaultJsonPath: string | null,
	) {
		const hoverElements = document.querySelectorAll(".step-hover");

		hoverElements.forEach((element) => {
			element.addEventListener("mouseenter", () => {
				const lottieContainer = element.closest("[data-lottie-json]");
				const jsonUrl = lottieContainer?.getAttribute("data-lottie-json");

				if (jsonUrl && animationContainer) {
					this.loadAnimation(animationContainer, jsonUrl, true);
				}
			});

			element.addEventListener("mouseleave", () => {
				if (defaultJsonPath && animationContainer) {
					this.loadAnimation(animationContainer, defaultJsonPath, true);
				}
			});
		});
	}
}

export default OurApproach;
